import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import { semantic_colors } from '../../foundation';
import { SectionTitle, SectionTitleProps } from '../section-title';
import { Breadcrumb, BreadcrumbProps, Stack } from '../../components';
export interface PageHeaderProps {
  /** @default false */
  dense?: boolean;
  /** @default true */
  border?: boolean;
  /** @deprecated 스펙아웃될 예정입니다. SectionTitle 삽입시 sectionTitleProps를 이용해주세요. */
  children?: React.ReactNode;
  /**
   * [sectionTitleProps](https://storybook.kakaostyle.in/master/pds/?path=/docs/container-sectiontitle--docs)
   * - PageHeader내 SectionTitle 주입이 필요할 경우 SectionTitle Props 정보를 전달하면 children 요소로써 자동 생성됩니다.
   * - SectionTitle의 안전 여백은 PageHeader에서 사용시 자동 0으로 세팅되며, 필요시 SectionTitleProps에서 재정의할 수 있습니다.
   */
  sectionTitleProps?: SectionTitleProps;
  breadcrumbProps?: BreadcrumbProps;
}

export const PageHeader = ({
  dense = false,
  border = true,
  sectionTitleProps,
  breadcrumbProps,
  children,
}: PropsWithChildren<PageHeaderProps>) => {
  return (
    <Header dense={dense} border={border}>
      <Stack direction='column' gap={20}>
        {breadcrumbProps && <Breadcrumb {...breadcrumbProps} />}
        {sectionTitleProps && <SectionTitle mb={0} {...sectionTitleProps} />}
      </Stack>
      {children}
    </Header>
  );
};

const Header = styled.header<{ dense: boolean; border: boolean }>`
  width: 100%;
  background-color: ${semantic_colors.background.surface};
  ${({ border }) => border && `border-bottom: 1px solid ${semantic_colors.border.primary}`};
  padding: ${({ dense }) => (dense ? '16px 16px 32px' : '32px 40px')};
  overflow-wrap: break-word;
`;
